import Typography from "@mui/material/Typography";
import styles from "../../common/user/user.module.scss";
import commonStyles from "../../../App.module.scss";
import { Box, Card, Grid } from "@mui/material";
import { useState, useRef, useEffect } from "react";
import {
  CustomTextFeild,
  CustomRequiredInputLabel,
  CustomCalendarTodayOutlinedIcon,
  CustomDatePicker,
  StyledDateContainer,
  CustomLeftIcon,
  CommonOutlinedButton,
  CommonButton,
} from "../../common/StyledComponents/StyledFields";
import { useNavigate, useSearchParams } from "react-router-dom";
import constants from "../../../config/constants.json";
import {
  apiRequest,
  authService,
  catchErrorMessageHandler,
  checkAuthToken,
  getDevoteeId,
  getUserName,
  getaccessToken,
} from "../../../infrastructure/backendService";
import { object, string, ref, ValidationError } from "yup";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import { AxiosResponse, AxiosError } from "axios";
import apiPath from "../../../config/apiPaths.json";
import ToastError from "../../common/toast/toastError";
import toast, { Toaster } from "react-hot-toast";
import { isNil } from "lodash";
import SuccessComponent from "../../volunteerRegistration/successComponent/successComponent";
import { ClipLoader } from "react-spinners";
import SuccessPopup from "../../devotee/donation/successPopup";
import ErrorPopup from "../../common/ErrorPopup";
import PaymentCancelConfirmationDialog from "../../PaymentCancelConfirmation/PaymentCancelConfirmation";

interface ErrorMessageTypes {
  checkNo: string;
  checkDate: string;
  bankName: string;
}
interface CheckProps {
  setSelectedPaymentMode?: React.Dispatch<React.SetStateAction<string>>;
  amount?: number;
  setShowPayment?: React.Dispatch<React.SetStateAction<boolean>>;
  setShowSuccess?: React.Dispatch<React.SetStateAction<boolean>>;
  navigateBack?: () => void;
}

export default function ManagerCheckPayment(props: CheckProps) {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const navigate = useNavigate();
  const [paymentUserData, setPaymentUserData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    city: "",
    state: "",
    zipcode: "",
    country: "USA",
    address: "",
    amount: "",
  });
  const [errorMessage, setErrorMessage] = useState<ErrorMessageTypes>({
    checkNo: "",
    checkDate: "",
    bankName: "",
  });
  const [itemsList, setItemList] = useState<any[]>([]);
  const [showSuccessComponent, setShowSuccessComponent] =
    useState<boolean>(false);
  const [receiptID, setReceiptID] = useState<string>("");
  const [userID, setUserID] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const [isDatePickerOpen, setDatePickerOpen] = useState(false);

  useEffect(() => {
    const storedCartItems = sessionStorage.getItem("cartItems");
    if (storedCartItems) {
      const cartItemObjects = JSON.parse(storedCartItems);
      setItemList(cartItemObjects);
    }
  }, []);

  useEffect(() => {
    apiRequest({
      method: "GET",
      endpoint: `${apiPath.getDevoteeDetails}/${getDevoteeId()?.userId?.toUpperCase()}`,
      includeToken: true,
    })
      .then((res) => {
        setPaymentUserData({
          ...paymentUserData,
          firstName: res.data.firstname,
          lastName: res.data.lastname,
          address: res.data.address,
          city: res.data.city,
          state: res.data.state,
          zipcode: res.data.zipcode,
          country: res.data.country,
          email: res.data.email,
        });
        
      })
      .catch((err) => {
        console.log(err);

        toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
          duration: constants.TOAST_POPUP_DURATION,
        });
      });
  }, []);

  const validationSchema = object().shape({
    checkNo: string().required("Check Number is required"),
    checkDate: string().required("Check Date is required"),
    bankName: string().required("Bank Name is required"),
  });

  const [formData, setFormData] = useState({
    checkNo: "",
    checkDate: "",
    bankName: "",
  });
  const [searchParam] = useSearchParams();
  const amountPopulated = searchParam.get("amount");

  const [openPaymentCancelDialog, setOpenPaymentCancelDialog] = useState(false);

  const handleClose = () => {
    setOpenPaymentCancelDialog(false);
  }


  const handleCancel = () => {
    setFormData({
      checkNo: "",
      checkDate: "",
      bankName: "",
    });
    setOpenPaymentCancelDialog(false);
    props?.navigateBack?.();
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  const handleFieldChange = (field: string, value: any) => {
    if (field === "checkDate") {
      const formattedDate = dayjs(value, "MM-DD-YYYY");
      setDatePickerOpen(false);
      setFormData({
        ...formData,
        [field]: formattedDate.isValid()
          ? formattedDate.format("MM-DD-YYYY")
          : "",
      });
    } else {
      setFormData({
        ...formData,
        [field]: value,
      });
    }
  };

  const handleDatePickerClick = () => {
    setDatePickerOpen(true);
  };

  useEffect(() => {
      setDatePickerOpen(false);
    }, [formData.checkDate]);

  const handleSave = async (): Promise<void> => {
    const errors: ErrorMessageTypes = {
      checkNo: "",
      checkDate: "",
      bankName: "",
    };

    try {
      // Validate the form data against the validation schema
      await validationSchema.validate(formData, { abortEarly: false });
      // If validation passes, you can submit the form
      setErrorMessage(errors);
      // alert('Registration Successful');
      // Call your API or perform other actions here
      saveApiCall();
      // console.log("Register Successful")
    } catch (error: any) {
      // Handle validation errors

      if (error instanceof ValidationError) {
        error.inner.forEach((e: any) => {
          if (e.path) {
            errors[e.path as keyof ErrorMessageTypes] = e.message;
          }
        });
      }
      setErrorMessage(errors);
    }
  };

  const saveApiCall = () => {
    setLoading(true);
    const reqBody = {
      items: itemsList,
      modeOfPayment: 5,
      checkNumber: formData.checkNo,
      bankName: formData.bankName,
      checkDate: formData.checkDate,
    };

    //  setLoading(true);
    apiRequest({
      method: "POST",
      endpoint: apiPath.cartPayment,
      body: JSON.stringify(reqBody),
      includeToken:true
    })
      .then((res) => {
        console.log(res);
        props.setShowSuccess?.(true);
        setShowSuccessComponent(true);
        setReceiptID(res.data.receiptId);
        setUserID(res.data.userId);
        sessionStorage.removeItem("cartItems");
        setFormData({
          checkNo: "",
          checkDate: "",
          bankName: "",
        });
        setLoading(false);
        sessionStorage.setItem("showPaymentStatus", JSON.stringify(true));
        navigate(`/receipt?receiptID=${res.data.receiptId}&userID=${res.data.userId}`);
      })
      .catch((err) => {
        console.log(err);
        toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
          duration: constants.TOAST_POPUP_DURATION,
        });
        setLoading(false);
      });
  };

  const handleKeyPress = (e:any) => {
    if (e.key === 'Enter') {
      e.preventDefault(); // Prevent the default form submission behavior
      handleSave();
    }
  };

  const handleButtons = () => {
    return (
      <div style={{ display: "flex", gap: "10px" }}>
        <CommonOutlinedButton
          className={commonStyles.cancelButton}
          onClick={() => setOpenPaymentCancelDialog(true)}
        >
          Cancel
        </CommonOutlinedButton>
        <CommonButton className={commonStyles.saveButton} onClick={handleSave} disabled={loading}>
        {loading ? (
                <>
                  <ClipLoader color="#fff" loading={loading} size={15} />
                  <span
                    style={{
                      marginLeft: "8px",
                      fontSize: "15px",
                      textAlign: "center",
                    }}
                  >
                    Loading...
                  </span>
                </>
              ) : (
                "Make Payment"
              )}
        </CommonButton>
      </div>
    );
  };

  const DatePicker = (): React.ReactElement => {
    return (
      <div style={{ borderRadius: "8px" }}>
        <StyledDateContainer
        onClick={handleDatePickerClick}
          sx={{
            backgroundColor: "#FFF9E4",
            borderRadius: "8px",
            height: "48px",
          }}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateTimePicker"]}>
              <CustomDatePicker
               open={isDatePickerOpen}
               onClose={() => setDatePickerOpen(false)}
                slots={{
                  openPickerIcon: CustomCalendarTodayOutlinedIcon,
                }}
                slotProps={{
                  inputAdornment: {
                    position: "end",
                  },
                }}
                format="MM-DD-YYYY"
                value={
                  formData.checkDate
                    ? dayjs(formData.checkDate, "MM-DD-YYYY")
                    : ""
                }
                disablePast
                onChange={(value) => {
                  setErrorMessage({ ...errorMessage, checkDate: "" });
                  handleFieldChange("checkDate", value);
                }}
                className={
                  errorMessage.checkDate
                    ? styles.errorTextField
                    : styles.textField
                }
              />
            </DemoContainer>
          </LocalizationProvider>
          {errorMessage.checkDate ? (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessage.checkDate}
            </Typography>
          ) : (
            ""
          )}
        </StyledDateContainer>
      </div>
    );
  };

  const paymentComponent = () => {
    return (
      <form className={styles.ChequeContainer} style={{width:"100%", marginTop:"20px"}} onKeyDown={handleKeyPress}>
        <Box className={styles.backArrow}>
          <Typography className={styles.heading} sx={{fontSize:"20px"}}>Check Details</Typography>
        </Box>
        <Card className={styles.formContainer}>
          <Grid container spacing={2}>
            <Grid xs={12} sm={4} item sx={{ marginRight: "40px" }}>
              {CustomRequiredInputLabel("Check Number", true)}
              <CustomTextFeild
                fullWidth
                required
                value={formData.checkNo}
                onChange={(e) => {
                  setErrorMessage({ ...errorMessage, checkNo: "" });
                  handleFieldChange("checkNo", e.target.value);
                }}
                className={
                  errorMessage.checkNo
                    ? styles.errorTextField
                    : styles.textField
                }
                placeholder="Enter Check Number"
              />
              {errorMessage.checkNo && (
                <Typography sx={{ color: "red", fontSize: "12px" }}>
                  {errorMessage.checkNo}
                </Typography>
              )}
            </Grid>
            <Grid xs={12} sm={4} item sx={{ marginRight: "40px" }}>
              {CustomRequiredInputLabel("Cheque Date", true)}
              {DatePicker()}
            </Grid>
            <Grid xs={12} sm={4} item sx={{ marginRight: "40px" }}>
              {CustomRequiredInputLabel("Bank Name", true)}
              <CustomTextFeild
                fullWidth
                required
                value={formData.bankName}
                onChange={(e) => {
                  setErrorMessage({ ...errorMessage, bankName: "" });
                  handleFieldChange("bankName", e.target.value);
                }}
                className={
                  errorMessage.bankName
                    ? styles.errorTextField
                    : styles.textField
                }
                placeholder="Enter Bank Name"
              />
              {errorMessage.bankName && (
                <Typography sx={{ color: "red", fontSize: "12px" }}>
                  {errorMessage.bankName}
                </Typography>
              )}
            </Grid>
          </Grid>
        </Card>
        <div>{handleButtons()}</div>
      </form>
    );
  };

  return (
    <>
      <Toaster />
      {paymentComponent()}
      <PaymentCancelConfirmationDialog isOpen={openPaymentCancelDialog} handleClose={handleClose} handleCancel={handleCancel}/>
    </>
  );
}
